import { render, staticRenderFns } from "./LevyCollections.vue?vue&type=template&id=736e07fb&"
import script from "./LevyCollections.vue?vue&type=script&lang=js&"
export * from "./LevyCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports